<template>
  <div class="style-guide">
    <div class="row">
      <div class="small-12 columns">
        <h2>Buttons</h2>
        <p>
          Button style for Opoli Backoffice.<br/>
          <a class="button" href="#">BUTTON</a><br/>
          <code>class="button"</code>
        </p>

        <div class="row">
          <div class="small-3 columns">
            <h3>Size Modifiers</h3>

            <p>
              <a class="button xlarge" href="#">BUTTON</a><br/>
              <code>class="button xlarge"</code>
            </p>
            <p>
              <a class="button large" href="#">BUTTON</a><br/>
              <code>class="button large"</code>
            </p>
            <p>
              <a class="button small" href="#">BUTTON</a><br/>
              <code>class="button small"</code>
            </p>
            <p>
              <a class="button xsmall" href="#">BUTTON</a><br/>
              <code>class="button xsmall"</code>
            </p>
          </div>
          <div class="small-3 columns">
            <h3>Color Modifiers</h3>

            <p>
              <a class="button success" href="#">BUTTON</a><br/>
              <code>class="button success"</code>
            </p>
            <p>
              <a class="button error" href="#">BUTTON</a><br/>
              <code>class="button error"</code>
            </p>
            <p>
              <a class="button warning" href="#">BUTTON</a><br/>
              <code>class="button warning"</code>
            </p>
          </div>
          <div class="small-3 columns">
            <h3>CTA Button</h3>

            <p>
              <a class="button cta" href="#">BUTTON</a><br/>
              <code>class="button cta"</code>
            </p>
            <p>
              <a class="button cta success" href="#">BUTTON</a><br/>
              <code>class="button cta success"</code>
            </p>
            <p>
              <a class="button cta error" href="#">BUTTON</a><br/>
              <code>class="button cta error"</code>
            </p>
            <p>
              <a class="button cta warning" href="#">BUTTON</a><br/>
              <code>class="button cta warning"</code>
            </p>
          </div>
          <div class="small-3 columns">
            <h3>Block Button</h3>

            <p>
              <a class="button cta block" href="#">BUTTON</a>
              <code>class="button cta block"</code>
            </p>
          </div>
        </div>
      </div>

      <div class="small-12 columns">
        <h2>Status Labels</h2>
        <p>Label style for Opoli Backoffice.<br/><br/></p>

        <div class="row">
          <div class="small-3 columns">
            <span class="status complete">Completed</span><br/>
            <code>class="status complete"</code>
          </div>

          <div class="small-3 columns">
            <span class="status canceled">Canceled</span><br/>
            <code>class="status canceled"</code>
          </div>

          <div class="small-3 columns">
            <span class="status onboard">On board</span><br/>
            <code>class="status onboard"</code>
          </div>

          <div class="small-3 columns">
            <span class="status ready">Ready to go</span><br/>
            <code>class="status ready"</code>
          </div>
        </div>

        <div class="row">
          <br/>
          <div class="small-3 columns">
            <span class="status upcoming">upcoming</span><br/>
            <code>class="status upcoming"</code>
          </div>

          <div class="small-3 columns">
            <span class="status dispatched">dispatched</span><br/>
            <code>class="status dispatched"</code>
          </div>

          <div class="small-6 columns">
            <span class="status requires-dispatch">Requires Dispatch</span><br/>
            <code>class="status requires-dispatch"</code>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'style-guide',
  mounted () {
    this.$store.commit('sideMenu/hide')
    this.$store.commit('sideMenu/hideMenuButton')
  },
  destroyed () {
    this.$store.commit('sideMenu/showMenuButton')
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
</style>



// WEBPACK FOOTER //
// src/components/App/StyleGuide.vue